// Prod_US: the two videos, held until the second test is done. They stay in memory only: a
// page reload drops them, and the person records again. Apart from the upload itself so the
// person page and the menu can drop them without loading the storage SDK.
import { PROD_US_MODULE_IDS } from "./prodUsConfig";

const held = new Map(); // moduleId -> { file, moduleInfo, personId }

export const holdProdUsVideo = ({ moduleId, file, moduleInfo, personId }) => {
  if (!file || !moduleInfo || !personId) return false;
  held.set(Number(moduleId), {
    file,
    moduleInfo: { ...moduleInfo, moduleId: Number(moduleId) },
    personId,
  });
  return true;
};

export const hasAllProdUsVideos = () =>
  PROD_US_MODULE_IDS.every((id) => held.has(id));

export const heldProdUsModuleIds = () =>
  PROD_US_MODULE_IDS.filter((id) => held.has(id));

export const clearProdUsVideos = () => held.clear();

export const heldProdUsVideo = (moduleId) => held.get(moduleId);

export const releaseProdUsVideo = (moduleId) => held.delete(moduleId);
